import * as React from 'react';
import i18n from 'i18next';

const Intro = () => {
	return (
		<div id='intro'>
			<div>
				<h4>{i18n.t('DIST_LIST_INTRO_HEADER')}</h4>
				<p>{i18n.t('DIST_LIST_INTRO')}</p>
			</div>
		</div>
	)
}

export default Intro;